import Button from '@/components/base/button/button';
import PhosphorIcon from '@/components/base/icon/phosphor-icon';
import type { Icon as IconType, IconWeight } from '@phosphor-icons/react';
import { clsx } from 'clsx';
import type { ComponentPropsWithoutRef } from 'react';

interface IconButtonProps extends ComponentPropsWithoutRef<'button'> {
  Icon: IconType;
  iconVariant?: IconWeight;
  size?: 'default' | 'small' | 'large';
  isLoading?: boolean;
  classNameIcon?: string;
  testId?: string;
}

const sizeMap = {
  default: 'icon-m',
  small: 'icon-s',
  large: 'icon-l',
} as const;

const sizeClasses = {
  default: 'h-clickable w-clickable',
  small: 'h-clickable-minimum w-clickable-minimum',
  large: 'h-clickable-large w-clickable-large',
};

const IconButton = ({
  size = 'default',
  Icon,
  iconVariant = 'bold',
  classNameIcon,
  testId,
  ...props
}: IconButtonProps) => (
  <Button
    {...props}
    testId={testId}
    variant="tertiary-no-frame"
    size={size}
    className={clsx(sizeClasses[size], props.className ?? '!p-xxs')}
  >
    <PhosphorIcon
      Icon={Icon}
      className={clsx(sizeMap[size], classNameIcon, 'm-auto')}
      variant={iconVariant}
    />
  </Button>
);

export default IconButton;
